import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Shield } from "lucide-react";

// Placeholder GA id — wired at go-live (Phase 5). Consent Mode v2: analytics denied by default.
const GA_ID = "G-XXXXXXXXXX";
const STORAGE_KEY = "tworay-consent-v1";

function gtag() {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(arguments);
}

function applyConsent(granted) {
  gtag("consent", "update", {
    analytics_storage: granted ? "granted" : "denied",
    ad_storage: granted ? "granted" : "denied",
    ad_user_data: granted ? "granted" : "denied",
    ad_personalization: granted ? "granted" : "denied",
  });
  if (granted && GA_ID && !GA_ID.includes("XXX") && !window.__ga_loaded) {
    window.__ga_loaded = true;
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(s);
    gtag("js", new Date());
    gtag("config", GA_ID);
  }
}

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Consent Mode default = denied (strictly-necessary only) before any choice.
    gtag("consent", "default", {
      analytics_storage: "denied",
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
      wait_for_update: 500,
    });
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "granted") applyConsent(true);
    else if (!stored) setVisible(true);
  }, []);

  const choose = (granted) => {
    localStorage.setItem(STORAGE_KEY, granted ? "granted" : "denied");
    applyConsent(granted);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[60] p-4 sm:p-6" data-testid="cookie-banner">
      <div className="mx-auto max-w-4xl bg-navy text-white rounded-md shadow-2xl border border-white/10 p-5 sm:p-6 grain-overlay relative overflow-hidden">
        <div className="relative z-10 flex flex-col md:flex-row md:items-center gap-5">
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-2">
              <Shield size={18} className="text-cyan" />
              <span className="text-xs font-semibold tracking-[0.2em] uppercase text-cyan">Your privacy</span>
            </div>
            <p className="text-sm text-white/80 leading-relaxed">
              We use strictly-necessary cookies to run this site. With your consent we'd also use analytics cookies to improve it.
              Non-essential cookies stay off until you accept. See our{" "}
              <Link to="/legal/cookies" className="text-cyan underline underline-offset-2">Cookie Notice</Link>.
            </p>
          </div>
          <div className="flex gap-3 shrink-0">
            <button
              onClick={() => choose(false)}
              data-testid="cookie-reject"
              className="px-4 py-2.5 text-sm font-semibold rounded-sm border border-white/25 text-white hover:bg-white/10 transition-colors"
            >
              Reject non-essential
            </button>
            <button
              onClick={() => choose(true)}
              data-testid="cookie-accept"
              className="px-5 py-2.5 text-sm font-semibold rounded-sm bg-cyan text-navy hover:bg-white transition-colors"
            >
              Accept all
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
